import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css"; // Importation des styles d'AOS
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";

const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false); // État pour le chargement

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Démarrer le chargement

    emailjs
      .send(
        "service_ce36y2t",
        "template_f3msjlw",
        {
          to_name: formData.name,
          from_name: "webminds",
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "LA4k-ay9VBSUay3vU"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
          alert("Votre message a été envoyé avec succès !");
        },
        (err) => {
          console.error("FAILED...", err);
          alert("Erreur lors de l'envoi du message. Veuillez réessayer.");
        }
      )
      .finally(() => {
        setLoading(false); // Arrêter le chargement
      });
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 to-gray-800 min-h-screen text-white">
      <Helmet>
        <title>Contactez-nous | WebMinds</title>
        <meta
          name="description"
          content="Vous avez des questions ou un projet en tête ? Contactez WebMinds pour discuter de vos besoins en développement d'applications mobiles, conception graphique, et bien plus."
        />
        <meta
          name="keywords"
          content="contact, WebMinds, développement mobile, conception graphique, service client, assistance, contact entreprise"
        />
      </Helmet>

      <Navbar />

      <div className="max-w-4xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center mb-8" data-aos="fade-up">
          Contactez-nous
        </h2>
        <p
          className="text-center text-lg mb-12"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Avez-vous des questions ou besoin d'assistance ? Remplissez le
          formulaire ci-dessous,{" "}
          <span className="font-semibold">
            appelez-nous au{" "}
            <a
              href="tel:+33772293255"
              className="text-blue-400 hover:underline"
            >
              07 72 29 32 55
            </a>
          </span>
          , ou envoyez-nous un email à{" "}
          <a
            href="mailto:webminds.contact@gmail.com"
            className="text-blue-400 hover:underline"
          >
            webminds.contact@gmail.com
          </a>
          . Nous vous répondrons dans les plus brefs délais.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Formulaire de Contact */}
          <form
            className="space-y-6 bg-gray-800 p-8 rounded-lg shadow-lg"
            data-aos="fade-up"
            data-aos-delay="400"
            onSubmit={handleSubmit}
          >
            <div>
              <label htmlFor="name" className="block text-lg font-medium mb-2">
                Nom complet
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="p-3 w-full border border-gray-600 rounded-md bg-gray-900 text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Votre nom complet"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-lg font-medium mb-2">
                Adresse e-mail
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="p-3 w-full border border-gray-600 rounded-md bg-gray-900 text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="votreemail@example.com"
              />
            </div>
            <div>
              <label
                htmlFor="subject"
                className="block text-lg font-medium mb-2"
              >
                Sujet
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                required
                value={formData.subject}
                onChange={handleChange}
                className="p-3 w-full border border-gray-600 rounded-md bg-gray-900 text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sujet de votre message"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-lg font-medium mb-2"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="6"
                required
                value={formData.message}
                onChange={handleChange}
                className="p-3 w-full border border-gray-600 rounded-md bg-gray-900 text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Votre message..."
              ></textarea>
            </div>
            <div>
              <button
                type="submit"
                className={`w-full py-3 px-6 ${
                  loading ? "bg-gray-500" : "bg-blue-500"
                } text-white font-semibold rounded-md shadow-md hover:${
                  loading ? "bg-gray-600" : "bg-blue-600"
                } transition duration-300`}
                disabled={loading} // Désactiver le bouton pendant le chargement
              >
                {loading ? "Envoi..." : "Envoyer"} {/* Affiche le loader */}
              </button>
            </div>
          </form>

          {/* Informations de Contact */}
          <div className="space-y-8">
            <div
              className="bg-gray-800 p-8 rounded-lg shadow-lg"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <h3 className="text-2xl font-semibold mb-4">Nos coordonnées</h3>
              <p className="text-lg mb-2">
                <span className="font-semibold">Adresse :</span> 12 rue Sauve
                Delanoue, 77100 Meaux
              </p>
              <p className="text-lg mb-2">
                <span className="font-semibold">Téléphone :</span>{" "}
                <a
                  href="tel:+33772293255"
                  className="text-blue-400 hover:underline"
                >
                  07 72 29 32 55
                </a>
              </p>
              <p className="text-lg">
                <span className="font-semibold">Email :</span>{" "}
                <a
                  href="mailto:webminds.contact@gmail.com"
                  className="text-blue-400 hover:underline"
                >
                  webminds.contact@gmail.com
                </a>
              </p>
            </div>
            <div
              className="bg-gray-800 p-8 rounded-lg shadow-lg"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <h3 className="text-2xl font-semibold mb-4">
                Heures d'ouverture
              </h3>
              <p className="text-lg mb-2">
                <span className="font-semibold">Lundi - Vendredi :</span> 09:00
                - 18:00
              </p>
              <p className="text-lg mb-2">
                <span className="font-semibold">Samedi :</span> 10:00 - 14:00
              </p>
              <p className="text-lg">
                <span className="font-semibold">Dimanche :</span> Fermé
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
